// App-side delegate for `@heidi/templates/data`.
//
// The query moved. What stayed is the gate it could not take: `isAuthenticated`
// AND `useQueryUser().kinde_user_id`. Both are app reads, and injecting either
// would relocate the coupling rather than remove it — so the app composes
// them at the same render-time position and passes ONE boolean in. Call
// sites keep their exact signature.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  GET_ORGANIZATION_TEMPLATES_FILTERS_METADATA,
  type TemplateSearchFilterMetadataResponse,
} from '@heidi/templates/contracts';
import { useQueryOrganizationTemplatesFiltersMetadata as useQueryOrganizationTemplatesFiltersMetadataCore } from '@heidi/templates/data';
import { useQueryUser } from './useQueryUser';

export { GET_ORGANIZATION_TEMPLATES_FILTERS_METADATA };

export function useQueryOrganizationTemplatesFiltersMetadata<
  T = TemplateSearchFilterMetadataResponse,
>(organizationId: string, select?: (data: TemplateSearchFilterMetadataResponse) => T) {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: userData } = useQueryUser((data) => data?.kinde_user_id);

  return useQueryOrganizationTemplatesFiltersMetadataCore<T>(
    organizationId,
    select,
    Boolean(isAuthenticated && userData)
  );
}
